import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-crudbuttons',
  templateUrl: './crudbuttons.component.html',
  styleUrls: ['./crudbuttons.component.scss']
})
export class CRUDButtonsComponent {
  @Output() updateEvent = new EventEmitter();
  @Output() removeEvent = new EventEmitter();
  private btnDeleteProp = false;
  private btnUpdateProp = false;
  private btnAddProp = false;

  constructor() {
  }

  @Input()
  public get btnAdd() {
    return this.btnAddProp;
  }

  public set btnAdd(value) {
    this.btnAddProp = value;
  }

  @Input()
  public get btnUpdate() {
    return this.btnUpdateProp;
  }

  public set btnUpdate(value) {
    this.btnUpdateProp = value;
  }

  @Input()
  public get btnDelete() {
    return this.btnDeleteProp;
  }

  public set btnDelete(value) {
    this.btnDeleteProp = value;
  }

  update() {
    this.updateEvent.emit();
  }

  remove() {
    this.removeEvent.emit();
  }
}
